// =============================================================================
// state
// =============================================================================
const state = {
  showLoading: false,
  loadingCb: null,
  loadingTimer: null,
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  show_loading: state => state.showLoading,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_loading_cb: (state, value) => { state.loadingCb = value; },
  set_loading (state, value) {
    const tag = this._vm.$lib._$id('loading-main');
    if (value === true) {
      state.loadingTimer = setTimeout(state.loadingCb, 500);
      if (tag) {
        tag.style.display = 'none';
      }
    } else {
      if (tag) {
        tag.style.display = 'flex';
      }
      if (state.loadingTimer !== null) {
        clearTimeout(state.loadingTimer);
        state.loadingTimer = null;
      }
    }
    state.showLoading = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
